import {News} from "@/news/News"

export class NewsService {
  private readonly news: Array<News> = [
    {
      image:
        "https://www.plum.com.au/content/plum/en/news-information/hello-future/retire-ready/_jcr_content/par-col-body-2/bootstrap_row_2/col3/bootstrap_text_image/image.img.jpg/1575348668673.financially-savvy.jpg",
      date: "Feb 4, 2020",
      headline: "Are you financially savvy?",
      blurb:
        "We examine some common financial truisms to discover if they’re justified. The answers may surprise you.",
      url:
        "https://www.plum.com.au/news-information/hello-future/starting-out/are-you-as-financially-savvy",
    },
    {
      image:
        "https://www.plum.com.au/content/plum/en/news-information/hello-future/building-wealth/_jcr_content/par-col-body-2/bootstrap_row_2/col3/bootstrap_text_image/image.img.jpg/1573016291077.post-divorce-finances.jpg",
      date: "Nov 1, 2019",
      headline: "Control your finances post-divorce",
      blurb:
        "Starting over after divorce can be daunting and financially difficult. Here are some pointers on how to make the financial transition smoother.",
      url:
        "https://www.plum.com.au/planning-for-retirement/unplanned-life-events/taking-control-of-your-finances-post-divorce",
    },
    {
      image:
        "https://www.plum.com.au/content/plum/en/news-information/hello-future/retire-ready/_jcr_content/par-col-body-2/bootstrap_row_2/col2/bootstrap_text_image/image.img.jpg/1575348771664.senior-life.jpg",
      date: "October 21, 2019",
      headline: "Life just got a whole lot cheaper",
      blurb:
        "Reaching 60 unlocks a bonanza of financial rebates, discounts and concessions. Here’s how to start claiming them.",
      url:
        "https://www.plum.com.au/planning-for-retirement/stay-happy-and-healthy-in-retirement/life-got-cheaper",
    },
    {
      image:
        "https://www.plum.com.au/content/plum/en/news-information/hello-future/retire-ready/_jcr_content/par-col-body-2/bootstrap_row_2/col1/bootstrap_text_image/image.img.jpg/1573100627135.stay-mentally-sharp.jpg",
      date: "Aug 19, 2019",
      headline: "Easy ways to stay mentally sharp",
      blurb:
        "We bust the myth that mental decline is an inevitable part of ageing. Find out how to power your brain.",
      url:
        "https://www.plum.com.au/planning-for-retirement/stay-happy-and-healthy-in-retirement/stay-mentally-sharp",
    },
  ]

  getNews(): Array<News> {
    // Using only 3 items because of layout
    return this.news.slice(0, 3)
  }
}
